'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var chunk = exports.chunk = function chunk(str) {
  var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

  var results = [];
  var i = void 0;
  var len = void 0;

  for (i = 0, len = str.length; i < len; i += chunkSize) {
    results.push(str.substr(i, chunkSize));
  }

  return results;
};

var truncate = exports.truncate = function truncate(str, userOptions) {
  var defaultOptions = {
    desiredLength: 20,
    softTruncate: true,
    showEllipsis: true
  };

  var options = Object.assign({}, defaultOptions, userOptions);

  var desiredLength = options.desiredLength,
      softTruncate = options.softTruncate,
      showEllipsis = options.showEllipsis;


  if (str.length <= desiredLength) {
    return str;
  }

  var trimmedString = str.substr(0, desiredLength);
  if (softTruncate && trimmedString.lastIndexOf(' ') > 0) {
    trimmedString = trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' ')));
  }
  return '' + trimmedString + (showEllipsis ? '\u2026' : '');
};

var softHyphenate = exports.softHyphenate = function softHyphenate(str) {
  var minLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var chunkSize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;

  var words = str.split(' ');
  return words.map(function (word) {
    if (word.length >= minLength) {
      return chunk(word, chunkSize).join('\xAD');
    }
    return word;
  }).join(' ');
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-string/lib/index.js
// module id = 375
// module chunks = 1